import type React from "react";
import {memo, useCallback, useMemo} from "react";

import Languages from "../../constant/languages";
import SelectGeneric from "../SelectGeneric";

export type SelectLanguageOption = Omit<(typeof Languages)[number], "isFixed">;

export type Props = {
    value?: string;
    languages?: string[];
    onSelectedOption: (option: SelectLanguageOption) => void;
};

const SelectLanguage: React.FC<Props> = ({value, languages, onSelectedOption}) => {
    // simply provide the options and selected value
    const options = useMemo<SelectLanguageOption[]>(() => {
        return Languages.filter(elem => {
            return languages ? languages.indexOf(elem.value) > -1 : true;
        });
    }, [languages]);

    const selectedOption = useMemo<SelectLanguageOption>(() => {
        if (value) {
            const option = options.find(elem => {
                return value === elem.value;
            });
            if (option) {
                return option;
            }
        }

        return {
            value: "default",
            label: "Default"
        };
    }, [value, options]);

    const handleChange = useCallback(
        (value: string) => {
            const option = options.find(elem => {
                return value === elem.value;
            });
            if (option) {
                onSelectedOption(option);
            }
        },
        [options, onSelectedOption]
    );

    return (
        <SelectGeneric
            isClearable={false}
            isSearchable={false}
            maxMenuHeight={190}
            options={options}
            placeholder="Languages..."
            testID="select-language"
            value={selectedOption.value}
            onChange={handleChange}
        />
    );
};

export default memo(SelectLanguage);
